import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import './Home.css'
import App from './App'
import { SidebarProvider } from './context/SidebarContext'
import { CurrencyProvider } from './context/CurrencyContext'
import ThemedSuspense from './components/ThemedSuspense'
import 'process/browser';
import reportWebVitals from '../src/reportWebVitals';

// Register the push notification service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/sw.js`;
    navigator.serviceWorker.register(swUrl).catch((err) => {
      console.error('[SW] Registration failed:', err);
    });
  });
}

ReactDOM.render(
    <SidebarProvider>
    <CurrencyProvider>
      <Suspense fallback={<ThemedSuspense />}>
        <App />
      </Suspense>
    </CurrencyProvider>
    </SidebarProvider>,
  document.getElementById('root')
)
reportWebVitals();
